import "./../login/login.css";

import "./splash.css";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Logo from "./../../assets/logo.svg";
import { TailSpin } from "react-loader-spinner";
import axios from "../../network/api";
import AppConstants from "../AppConstants";

function Splash() {
  const navigate = useNavigate();

  useEffect(() => {
    // localStorage.clear();

    setTimeout(() => {
      let authToken = localStorage.getItem(AppConstants.JWT);
      if (authToken === null) {
        // This means that there ISN'T JWT and no user is logged in.
        axios.defaults.headers.common.Authorization = null;
        navigate("../login", { replace: true });
      } else {
        // This means that there IS a JWT so someone must be logged in.
        axios.defaults.headers.common.Authorization = `Bearer ${authToken}`;
        navigate("../home", { replace: true });
      }
    }, 4000);
  });

  return (
    <section id="login">
      <div className="content">
        <div className="brand-container">
          <img src={Logo} className="logo" alt="logo"/>
          <div className="business-name">Onescribe Super Admin Panel</div>

          <TailSpin
            className="splash-spinner"
            height="30"
            width="30"
            radius="1"
            color="#ffbe00"
            ariaLabel="loading"
            visible={true}
            // wrapperStyle
            // wrapperClass
          />
        </div>
      </div>

      <a href="tel:+919481815122" className="contact">
        ⓘ Contact Us
      </a>
    </section>
  );
}

export default Splash;
